<template>
  <v-container fluid>
    <div class="d-flex pt-2">
      <div class="align-self-center">
        <div>
          <div v-if="0">
            <v-autocomplete style="max-width: 400px;" v-model="selected_devices" :items="device_ids" outlined chips
              small-chips :label="$t('search_device_ids')" multiple></v-autocomplete>
          </div>
          <div>
            <v-autocomplete style="max-width: 400px;" v-model="selected_consumption_points" :items="consumption_points"
              outlined chips small-chips :label="$t('search_consumption_point')" multiple></v-autocomplete>
          </div>
        </div>
      </div>

      <v-divider vertical class="ml-8 mr-8"></v-divider>

      <div class="align-self-center">
        <div>
          <div class="">
            <div class="d-flex justify-space-between align-center">
              <v-text-field class="pt-0" v-model="start_time_display" :label="$t('start_time')"
                prepend-icon="mdi-calendar" @focus="show_end_date_picker = true; openStartTimeDialog($event)">
              </v-text-field>
              <datetime format="yyyy-MM-dd HH:mm:ss" class="pl-3" ref="start_time_dialog" v-model="start_time"
                type="datetime">
              </datetime>

            </div>
          </div>
          <div class="">
            <div class="d-flex justify-space-between align-center">
              <v-text-field class="pt-0" v-model="end_time_display" :label="$t('end_time')" prepend-icon="mdi-calendar"
                @focus="show_end_date_picker = true; openEndTimeDialog($event)">
                <template v-slot:label>

                </template>
              </v-text-field>
              <datetime format="yyyy-MM-dd HH:mm:ss" class="pl-3" ref="end_time_dialog" v-model="end_time"
                type="datetime">
              </datetime>

            </div>
          </div>
        </div>
      </div>

      <v-divider vertical class="ml-8 mr-8"></v-divider>

      <div class="align-self-center">
        <div class="d-flex">
          <v-checkbox v-model="selected_interval" v-for="type in report_interval_type" :key="type.value"
            :label="type.text" :value="type.value" class="mt-2 mr-5"></v-checkbox>
        </div>
        <div>
          <v-select v-model="num_decimal_places" :items="[0, 1, 2, 3, 4, 5]" :label="$t('num_decimal_places')"
            class="mt-2" dense outlined style="max-width: 250px;"></v-select>
        </div>
      </div>

      <v-divider vertical class="ml-8 mr-8"></v-divider>

      <div class="align-self-center">
        <v-btn @click="generateReport" :disabled="!can_start_report_calculation">

          {{ $t("generate_report") }}
        </v-btn>

        <v-progress-linear height="25" class="mt-5" v-if="report_progress !== null" v-model="report_progress"
          :buffer-value="100">
          <template v-slot:default="{ value }">
            <strong>{{ Math.ceil(value) }}%</strong>
          </template>
        </v-progress-linear>

        <div v-if="report_file" class="mt-5">
          <v-btn prepend-icon="mdi-download" small class="ma-2" @click="downloadFile(report_id_created,report_file)">
            <template v-slot:prepend>
              <v-icon color="success">mdi-download</v-icon>
            </template>
            {{ $t("download_report") }}
          </v-btn>
        </div>
      </div>
    </div>

    <v-row>
      <v-col cols="12">
        <v-tabs>
          <v-tab>
            <v-icon left>
              mdi-cup-water
            </v-icon>
            {{ $t("volume_events") }}
          </v-tab>
          <v-tab>
            <v-icon left>
              mdi-calendar-alert
            </v-icon>
            {{ $t("tamper_events") }}
          </v-tab>
          <v-tab>
            <v-icon left>
              mdi-progress-upload
            </v-icon>
            {{ $t("load_profile") }}
          </v-tab>

          <v-tab>
            <v-icon left>
              mdi-clipboard-list-outline
            </v-icon>
            {{ $t("event_log") }}
          </v-tab>

          <v-tab>
            <v-icon left>
              mdi-clipboard-list-outline
            </v-icon>
            {{ $t("install_events") }}
          </v-tab>


          <v-tab-item>
            <AmrTable :selected_dates="null" :selected_devices="selected_devices" :selected_tabletype="1"
              :selected_consumption_points="selected_consumption_points" :is_in_modal="false" :start_time="start_time"
              :end_time="end_time">
            </AmrTable>
          </v-tab-item>
          <v-tab-item>
            <AmrTable :selected_dates="null" :selected_devices="selected_devices" :selected_tabletype="2"
              :selected_consumption_points="selected_consumption_points" :is_in_modal="false" :start_time="start_time"
              :end_time="end_time"></AmrTable>
          </v-tab-item>
          <v-tab-item>
            <AmrTable :selected_dates="null" :selected_devices="selected_devices" :selected_tabletype="3"
              :selected_consumption_points="selected_consumption_points" :is_in_modal="false" :start_time="start_time"
              :end_time="end_time"></AmrTable>
          </v-tab-item>

          <v-tab-item>
            <AmrTable :selected_dates="null" :selected_devices="selected_devices" :selected_tabletype="5"
              :selected_consumption_points="selected_consumption_points" :is_in_modal="false" :start_time="start_time"
              :end_time="end_time"></AmrTable>
          </v-tab-item>

          <v-tab-item>
            <AmrTable :selected_tabletype="4" :selected_consumption_points="selected_consumption_points"
              :selected_dates="null" :selected_devices="selected_devices" :is_in_modal="false" :start_time="start_time"
              :end_time="end_time"></AmrTable>
          </v-tab-item>

        </v-tabs>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AmrTable from "@/components/tables/AmrTable";
import { Settings } from 'luxon'
import axios from "axios";
import moment from "moment";

export default {
  name: "Reports",
  components: { AmrTable },
  data() {
    return {
      dates: [],
      start_time: '',
      end_time: '',
      selected_dates_display: '',
      show_calendar: false,
      items: [],
      selected_devices: [],
      selected_consumption_points: [],
      show_end_date_picker: false,
      selected_interval: ['hourly'],
      num_decimal_places: 2,
      report_id_in_creation: null,
      report_progress: null,
      report_file: null,
      report_id_created: null
    }
  },
  created() {
    this.getDevices();
  },
  mounted() {
    this.end_time = moment().toISOString();
    this.start_time = moment().subtract(7, 'days').toISOString();
    this.$nextTick(() => {
      Settings.defaultLocale = this.language
    })
  },
  computed: {
    ...mapState('amr', ['device_ids', 'consumption_points']),
    ...mapState('user', ['language']),
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
    report_interval_type() {
      return [
        { text: this.$t('hourly'), value: 'hourly' },
        { text: this.$t('daily'), value: 'daily' },
        { text: this.$t('monthly'), value: 'monthly' },
        // { text: this.$t('yearly'), value: 'yearly' }
      ]
    },
    start_time_display() {
      return this.start_time ? moment(this.start_time).format('YYYY-MM-DD HH:mm:ss') : this.$t('start_time_not_set')
    },
    end_time_display() {
      return this.end_time ? moment(this.end_time).format('YYYY-MM-DD HH:mm:ss') : this.$t('end_time_not_set')
    },
    can_start_report_calculation() {
      return this.start_time && this.end_time && (this.selected_devices.length > 0 || this.selected_consumption_points.length > 0)
    }
  },
  methods: {
    ...mapActions('amr', ['get_devices']),
    getDevices() {
      this.get_devices();
    },
    openStartTimeDialog(event) {
      console.log('opening start time dialog' +
        '')
      this.$refs.start_time_dialog.open(event)
    },
    openEndTimeDialog(event) {
      this.$refs.end_time_dialog.open(event)
    },
    async downloadFile(id, name) {
      const fileUrl = `/api/amr/reports/download/${id}`;

      try {
        const response = await axios.get(fileUrl, {
          responseType: 'blob', // very important!
          headers: { Authorization: `Token ${localStorage.getItem('token')}` }
        });

        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', name.split('/').pop()); // set desired filename
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl); // cleanup
      } catch (error) {
        console.error('Download failed:', error);
      }
    },
    checkReportStatus() {
      if (this.report_id_in_creation) {
        axios.get(`/api/amr/reports/${this.report_id_in_creation}/status`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('token')}`
          },
        })
          .then(response => {
            const response_data = response.data;
            console.log("Report status: ", response_data);
            if (response_data.status === 'completed') {
              this.report_id_in_creation = null;
              // Optionally, you can trigger a download or notify the user
              console.log("Report completed successfully.");
            } else if (response_data.status === 'in_progress') {
              console.log("Report is still in progress.");
            } else {
              console.error("Report failed or unknown status.");
            }

            if (response_data.progress !== undefined) {
              this.report_progress = response_data.progress;
            } else {
              this.report_progress = null;
            }

            if (response_data.file) {
              this.report_file = response_data.file;
            } else {
              this.report_file = null;
            }

            if(response_data.id) {
              this.report_id_created = response_data.id;
            } else {
              this.report_id_created = null;
            }

          })
          .catch(error => {
            console.error("Error checking report status: ", error);
          });
      } else {
        console.log("No report is currently being generated.");
        clearInterval(this.interval);
      }
    },
    generateReport() {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.report_progress = null; // Reset progress
      this.report_file = null; // Reset file
      console.log("Timezone: ", timezone);
      axios.get('/api/amr/reports/create', {
        params: {
          selected_devices: this.selected_devices.join(),
          selected_consumption_points: this.selected_consumption_points.join(),
          interval: this.selected_interval.join(','),
          start_time: this.start_time_display,
          end_time: this.end_time_display,
          num_decimal_places: this.num_decimal_places,
          timezone: timezone,
        },
        headers: {
          Authorization: `Token ${localStorage.getItem('token')}`
        },
      })
        .then(response => {
          const reponse_data = response.data;
          console.log("Report started ", response)
          console.log("Got csv");
          if (reponse_data.report_id) {
            this.report_id_in_creation = reponse_data.report_id;
            this.interval = setInterval(this.checkReportStatus, 1000); // Check every 5 seconds
          } else {
            this.report_id_in_creation = null;
          }

          // const blob = new Blob([response.data])
          // const link = document.createElement('a')
          // link.href = URL.createObjectURL(blob)
          // link.download = `report_${this.selected_interval}_${this.start_time}_${this.end_time}.xlsx`
          // link.click()
          // URL.revokeObjectURL(link.href);
        })
    }
  },
  i18n: {
    messages: {
      sl: {
        tamper_events: "Izjemni dogodki",
        volume_events: "Skupni odčitki",
        load_profile: "Profil porabe",
        event_log: "Zgodovina dogodkov",
        install_events: "Inštalacijska sporočila",
        search_device_ids: "Išči po serijski št.",
        search_consumption_point: "Išči po odjemnem mestu",
        select_dates: "Izberi datume",
        add_start_time: "Izberi začetni čas",
        start_time_not_set: "Začetni čas ni izbran",
        add_end_time: "Izberi končni čas",
        end_time_not_set: "Končni čas ni izbran",
        start_time: "Začetni čas",
        end_time: "Končni čas",
        hourly: "Urni",
        daily: "Dnevni",
        monthly: "Mesečni",
        yearly: "Letni",
        generate_report: "Ustvari poročilo",
        num_decimal_places: "Število decimalnih mest",
        download_report: "Prenesi poročilo",
      },
      en: {
        tamper_events: "Tamper events",
        volume_events: "Volume events",
        load_profile: "Load profile",
        event_log: "Event log",
        install_events: "Install events",
        search_device_ids: "Search by device ID",
        search_consumption_point: "Search by consumption point",
        select_dates: "Select dates",
        add_start_time: "Add start time",
        start_time_not_set: "Start time not set",
        add_end_time: "Add end time",
        end_time_not_set: "End time not set",
        start_time: "Start time",
        end_time: "End time",
        hourly: "Hourly",
        daily: "Daily",
        monthly: "Monthly",
        yearly: "Yearly",
        generate_report: "Generate report",
        num_decimal_places: "Number of decimal places",
        download_report: "Download report",
      },
    }
  }
}
</script>

<style>
.vdatetime .vdatetime-input {
  display: none !important;
}
</style>
